module.exports = __webpack_public_path__ + "assets/Retina-Book.7033b8f58054f0180c90a32395faf73c.woff2";